import { ReactElement } from "react"

import CreateEVDCDeviceForm from "../../../../components/devices/lct/evdc/createEVDCDeviceForm"
import ContinueEVDCDeviceVersionProvider from "../../../../components/devices/lct/evdc/providers/continueEVDCDeviceVersionProvider"

const ContinueEVDCDraftDeviceVersion = (): ReactElement => (
    <ContinueEVDCDeviceVersionProvider>
        <CreateEVDCDeviceForm />
    </ContinueEVDCDeviceVersionProvider>
)

export default ContinueEVDCDraftDeviceVersion
